import {
	initTracking,
	resetAnalytics,
	trackPageView,
} from 'features/Analytics/AnalyticsUtils';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const Analytics = () => {
	const location = useLocation();

	useEffect(() => {
		initTracking();

		return () => {
			// ensure reset only happens after init
			resetAnalytics();
		};
	}, []);

	useEffect(() => {
		const handleRouteChange = () => {
			trackPageView();
		};

		handleRouteChange();
	}, [location.pathname]);

	return null;
};

Analytics.displayName = 'Analytics';
